import { useSearchParams } from 'react-router-dom';

import { SearchParams } from '@/shared/constants/search-params.constant';

import { useSelectedHistogramRedux } from '../selectors/select-create-histogram-form.selector';

export const useSelectedHistogram = () => {
	const selectedHistogram = useSelectedHistogramRedux();
	const [searchParams] = useSearchParams();
	const searchParamId = searchParams.get(SearchParams.YachtTrack);

	if (searchParamId) {
		return searchParamId;
	}

	return selectedHistogram;
};
